import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FxLayoutDirective } from './directives/fx-layout.directive';
import { LoaderDirective } from './directives/loader.directive';
import { CssDirective } from './directives/css.directive';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { NameIconPipe } from './pipes/name-icon.pipe';
import { ProgressBarColor } from './directives/progress-bar-color';
import { MinuteSecondsPipe } from './pipes/minute-seconds.pipe';
import { FileUploadDirective } from './directives/file-upload.directive';
import { TooltipDirective } from './directives/tooltip.directive';
import { CheckboxValueDirective } from './directives/checkbox-value.directive';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { HttpInterceptorService } from './services/http-interceptor.service';
import { ContentManagementService } from '../main/multi-game-play/services/content-management-service/content-management.service';
import { PracticeSetAccessDialogComponent } from '../main/content-management/modules/practice-set-detail/practice-set-access-dialog/practice-set-access-dialog.component';
import { MatIconModule } from '@angular/material/icon';
import { AllowSpecialCharactersDirective } from './directives/AllowSpecialCharactersDirective';
import { AllowSpecialCharactersDirective25 } from './directives/AllowSpecialCharactersDirective25';
import { ZoomableDirective } from './directives/zoomable'; //SG-6671
import { NgxDocViewerModule } from 'ngx-doc-viewer';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { HighchartsComponent } from './highcharts/highcharts.component';
import { HighchartsChartModule } from 'highcharts-angular';
import { ReusableDropdownComponent } from './reusable-dropdown/reusable-dropdown.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { ConfirmationDialogComponent } from './confirmation-dialog/confirmation-dialog.component';
import { ReusableAngleSelectorComponent } from './reusable-angle-selector/reusable-angle-selector.component';
import { ReusableSliderComponent } from './reusable-slider/reusable-slider.component';
import { ReusablePopUpComponent } from './reusable-pop-up/reusable-pop-up.component';
import { PopUpService } from './services/pop-up-service.service';
import { FormsModule } from '@angular/forms';
import { MatSliderModule } from '@angular/material/slider';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { ClickOutsideDirective } from './directives/ClickOutsideDirective';
import { CounterComponent } from './reusable-counter/counter/counter.component';
 

@NgModule({
  declarations: [
    ReusableDropdownComponent,
    ReusableAngleSelectorComponent,
    ReusableSliderComponent,
    ReusablePopUpComponent,
    PracticeSetAccessDialogComponent,
    HighchartsComponent,
    FxLayoutDirective,
    LoaderDirective,
    CssDirective,
    NameIconPipe,
    ProgressBarColor,
    MinuteSecondsPipe,
    FileUploadDirective,
    TooltipDirective,
    CheckboxValueDirective,
    AllowSpecialCharactersDirective,
    AllowSpecialCharactersDirective25,
    ZoomableDirective,
    ReusableDropdownComponent,
    ConfirmationDialogComponent, //SG-6671
    ClickOutsideDirective,
    CounterComponent
  ],
  imports: [
    HighchartsChartModule,
    CommonModule,
    MatSnackBarModule,
    MatDialogModule,
    MatIconModule,
    MatDividerModule,
    NgxDocViewerModule,
    PdfViewerModule,
    MatFormFieldModule,
    MatSelectModule,
    FormsModule,
    MatSliderModule,
    MatCardModule,
    MatButtonModule,
    HttpClientModule
  ],
  exports: [
    FxLayoutDirective,
    CommonModule,
    CssDirective,
	  LoaderDirective,
    NameIconPipe,
    ProgressBarColor,
    MinuteSecondsPipe,
    FileUploadDirective,
    TooltipDirective,
    CheckboxValueDirective,
    AllowSpecialCharactersDirective,
    AllowSpecialCharactersDirective25,
    ZoomableDirective, //SG-6671
    PracticeSetAccessDialogComponent,
    MatDialogModule,
    HighchartsComponent,
    ReusableDropdownComponent,
    ConfirmationDialogComponent,
    ReusableDropdownComponent,
    ReusableAngleSelectorComponent,
    ReusableSliderComponent,
    ReusablePopUpComponent,
    ClickOutsideDirective,
    CounterComponent
  ],
  providers: [
    ContentManagementService,
    PopUpService
  ]
})
export class SharedModule { }
